<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-4" x="10.01" y="33.66" width="21.29" height="30.11" rx="4.45" ry="4.45"/>
  <path class="cls-4" d="m39.54,43.62c0,.08-.06.14-.14.14h-1.26c-.08,0-.14-.06-.14-.14,0-.08.06-.15.14-.15h1.26c.08,0,.14.06.14.15Z"/>
  <path class="cls-4" d="m40.54,39.32l-.48-.48c-.06-.06-.06-.15,0-.21.05-.06.15-.06.2,0l.48.48c.06.06.06.15,0,.21-.03.02-.06.04-.1.04s-.08-.02-.1-.04Z"/>
  <path class="cls-4" d="m40.94,47.7c.06.06.06.15,0,.21l-.48.48s-.06.04-.1.04-.08-.01-.1-.04c-.06-.05-.06-.15,0-.2l.48-.48c.05-.05.15-.05.2,0Z"/>
  <path class="cls-4" d="m44.89,37.97v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14Z"/>
  <path class="cls-4" d="m45.18,49.25v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
  <path class="cls-4" d="m49.81,48.18c.05.05.05.15,0,.2-.03.03-.06.04-.1.04-.04,0-.08-.01-.11-.04l-.48-.48c-.05-.05-.05-.15,0-.21.06-.05.15-.05.21,0l.48.48Z"/>
  <path class="cls-4" d="m49.13,39.32c-.05-.06-.05-.15,0-.21l.48-.48c.06-.06.15-.06.21,0,.05.06.05.15,0,.21l-.48.48s-.06.04-.11.04c-.04,0-.07-.02-.1-.04Z"/>
  <path class="cls-4" d="m49.86,45.84c-.08.16-.23.25-.39.25-.06,0-.12-.01-.18-.04l-4.58-2.12-1.78-4.52c-.09-.22.02-.47.25-.56.22-.09.47.02.56.25l.38.97,1.27,3.22,3.28,1.51,1,.46c.22.1.31.35.21.57Z"/>
  <path class="cls-4" d="m52.07,43.62c0,.08-.06.14-.15.14h-1.25c-.08,0-.15-.06-.15-.14,0-.08.06-.15.15-.15h1.25c.08,0,.15.06.15.15Z"/>
  <path class="cls-4" d="m53.08,23.45h-16.08c-1.44,0-2.61,1.17-2.61,2.61v35.09c0,1.44,1.17,2.61,2.61,2.61h16.08c1.43,0,2.61-1.17,2.61-2.61V26.07c0-1.44-1.17-2.61-2.61-2.61Zm-8.04,27.82c-4.23,0-7.66-3.44-7.66-7.66s3.43-7.67,7.66-7.67,7.66,3.44,7.66,7.67-3.44,7.66-7.66,7.66Z"/>
  <rect class="cls-4" x="58.76" y="13.17" width="21.29" height="50.6" rx="4.45" ry="4.45"/>
  <g>
    <path class="cls-3" d="m72.79,73.26H11.44c-.79,0-1.42-.64-1.42-1.44s.64-1.44,1.42-1.44h61.35c.79,0,1.42.64,1.42,1.44s-.64,1.44-1.42,1.44Z"/>
    <path class="cls-3" d="m72.2,76.81l7.51-4.38c.46-.27.46-.94,0-1.21l-7.51-4.38c-.46-.27-1.03.07-1.03.6v8.76c0,.54.57.87,1.03.6Z"/>
  </g>
  <path class="cls-1" d="m39.54,43.62c0,.08-.06.14-.14.14h-1.26c-.08,0-.14-.06-.14-.14,0-.08.06-.15.14-.15h1.26c.08,0,.14.06.14.15Z"/>
  <path class="cls-1" d="m40.54,39.32l-.48-.48c-.06-.06-.06-.15,0-.21.05-.06.15-.06.2,0l.48.48c.06.06.06.15,0,.21-.03.02-.06.04-.1.04s-.08-.02-.1-.04Z"/>
  <path class="cls-1" d="m40.94,47.7c.06.06.06.15,0,.21l-.48.48s-.06.04-.1.04-.08-.01-.1-.04c-.06-.05-.06-.15,0-.2l.48-.48c.05-.05.15-.05.2,0Z"/>
  <path class="cls-1" d="m44.89,37.97v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14Z"/>
  <path class="cls-1" d="m45.18,49.25v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
  <path class="cls-1" d="m49.81,48.18c.05.05.05.15,0,.2-.03.03-.06.04-.1.04-.04,0-.08-.01-.11-.04l-.48-.48c-.05-.05-.05-.15,0-.21.06-.05.15-.05.21,0l.48.48Z"/>
  <path class="cls-1" d="m49.13,39.32c-.05-.06-.05-.15,0-.21l.48-.48c.06-.06.15-.06.21,0,.05.06.05.15,0,.21l-.48.48s-.06.04-.11.04c-.04,0-.07-.02-.1-.04Z"/>
  <path class="cls-1" d="m49.86,45.84c-.08.16-.23.25-.39.25-.06,0-.12-.01-.18-.04l-4.58-2.12-1.78-4.52c-.09-.22.02-.47.25-.56.22-.09.47.02.56.25l.38.97,1.27,3.22,3.28,1.51,1,.46c.22.1.31.35.21.57Z"/>
  <path class="cls-1" d="m45.03,35.37c-4.55,0-8.23,3.69-8.23,8.24s3.69,8.23,8.23,8.23,8.23-3.69,8.23-8.23-3.69-8.24-8.23-8.24Zm0,15.9c-4.23,0-7.66-3.44-7.66-7.66s3.43-7.67,7.66-7.67,7.66,3.44,7.66,7.67-3.44,7.66-7.66,7.66Z"/>
  <path class="cls-1" d="m52.07,43.62c0,.08-.06.14-.15.14h-1.25c-.08,0-.15-.06-.15-.14,0-.08.06-.15.15-.15h1.25c.08,0,.15.06.15.15Z"/>
  <path class="cls-2" d="m45.03,34.8c-4.85,0-8.81,3.96-8.81,8.82s3.96,8.81,8.81,8.81,8.81-3.96,8.81-8.81-3.95-8.82-8.81-8.82Zm0,16.47c-4.23,0-7.66-3.44-7.66-7.66s3.43-7.67,7.66-7.67,7.66,3.44,7.66,7.67-3.44,7.66-7.66,7.66Z"/>
  <g>
    <path class="cls-3" d="m45.18,36.72v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
    <g>
      <line class="cls-3" x1="40.16" y1="38.74" x2="40.64" y2="39.21"/>
      <path class="cls-3" d="m40.74,39.32s-.06.04-.1.04-.08-.02-.1-.04l-.48-.48c-.06-.06-.06-.15,0-.21.05-.06.15-.06.2,0l.48.48c.06.06.06.15,0,.21Z"/>
    </g>
    <g>
      <line class="cls-3" x1="40.37" y1="48.28" x2="40.84" y2="47.8"/>
      <path class="cls-3" d="m40.94,47.91l-.48.48s-.06.04-.1.04-.08-.01-.1-.04c-.06-.05-.06-.15,0-.2l.48-.48c.05-.05.15-.05.2,0,.06.06.06.15,0,.21Z"/>
    </g>
    <g>
      <line class="cls-3" x1="49.7" y1="48.28" x2="49.23" y2="47.8"/>
      <path class="cls-3" d="m49.81,48.38s-.06.04-.1.04c-.04,0-.08-.01-.11-.04l-.48-.48c-.05-.05-.05-.15,0-.21.06-.05.15-.05.21,0l.48.48c.05.05.05.15,0,.2Z"/>
    </g>
    <g>
      <line class="cls-3" x1="49.7" y1="38.74" x2="49.23" y2="39.22"/>
      <path class="cls-3" d="m49.81,38.84l-.48.48s-.06.04-.11.04c-.04,0-.07-.02-.1-.04-.05-.06-.05-.15,0-.21l.48-.48c.06-.06.15-.06.21,0,.05.06.05.15,0,.21Z"/>
    </g>
    <g>
      <line class="cls-3" x1="38.14" y1="43.61" x2="39.4" y2="43.61"/>
      <path class="cls-3" d="m39.54,43.62c0,.08-.06.14-.14.14h-1.26c-.08,0-.14-.06-.14-.14,0-.08.06-.15.14-.15h1.26c.08,0,.14.06.14.15Z"/>
    </g>
    <g>
      <line class="cls-3" x1="45.04" y1="50.5" x2="45.04" y2="49.25"/>
      <path class="cls-3" d="m45.18,49.25v1.26c0,.08-.06.14-.15.14-.08,0-.14-.06-.14-.14v-1.26c0-.08.06-.14.14-.14.08,0,.15.06.15.14Z"/>
    </g>
    <g>
      <line class="cls-3" x1="51.93" y1="43.61" x2="50.67" y2="43.61"/>
      <path class="cls-3" d="m52.07,43.62c0,.08-.06.14-.15.14h-1.25c-.08,0-.15-.06-.15-.14,0-.08.06-.15.15-.15h1.25c.08,0,.15.06.15.15Z"/>
    </g>
  </g>
  <g>
    <polygon class="cls-2" points="49.47 45.66 45.03 43.62 43.32 39.25 44.1 40.07 45.37 43.29 48.65 44.81 49.47 45.66"/>
    <path class="cls-2" d="m49.86,45.84c-.08.16-.23.25-.39.25-.06,0-.12-.01-.18-.04l-4.58-2.12-1.78-4.52c-.09-.22.02-.47.25-.56.22-.09.47.02.56.25l.38.97,1.27,3.22,3.28,1.51,1,.46c.22.1.31.35.21.57Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "TimeVolumeSalesTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #a3d7be;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: #cfeae0;
  }
</style>